// Beoflow Desktop (the Tauri app) opens the web app with ?beoflow_desktop=1 on every main-window
// URL. Remember that for the tab, so the login page can offer "Continue with Beoflow Desktop":
// the desktop stays signed in on its own, and when the web app's session is gone it can sign the
// web app back in. A marker, not a credential — anyone can set it, and all it does is show a
// button whose target (/desktop-signin) only the desktop app acts on. Not the user agent: the
// desktop shell can only REPLACE its webview's UA, which would break our own UA checks.

const MARKER_PARAM = 'beoflow_desktop'
const STORAGE_KEY = 'beoflow.desktop-shell'

/** Call once at boot, before analytics: records the marker and strips it from the URL. */
export function consumeDesktopShellMarkerFromUrl(
  win: Pick<Window, 'location' | 'history' | 'sessionStorage'> = window,
): void {
  const url = new URL(win.location.href)
  if (url.searchParams.get(MARKER_PARAM) !== '1') return
  try {
    win.sessionStorage.setItem(STORAGE_KEY, '1')
  } catch {
    // Storage refused (privacy mode): the button just stays hidden.
  }
  url.searchParams.delete(MARKER_PARAM)
  win.history.replaceState(win.history.state, '', `${url.pathname}${url.search}${url.hash}`)
}

export function isInDesktopShell(storage: Pick<Storage, 'getItem'> = window.sessionStorage): boolean {
  try {
    return storage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

/** Where "Continue with Beoflow Desktop" goes. A full navigation, so the desktop shell sees it. */
export function desktopSigninPath(): string {
  return `${import.meta.env.BASE_URL}desktop-signin`
}
